module.exports = __webpack_public_path__ + "static/img/fiscalia_general.2e645db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiscalia_general.png
// module id = 9KGP
// module chunks = 9